var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-bar'),_c('content-container',[_c('nav-bar'),_c('b-overlay',{attrs:{"show":_vm.showOverlay}},[_c('div',{staticStyle:{"min-height":"100vh","padding-top":"90px"}},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }